import { ResourceType } from '@getaccept/lib-shared/src/resources/types/enum/resource-type';

export const defaultResourceFilter = {
  resourceType: ResourceType.Template,
  offset: 0,
  directory: '',
  searchTerms: [],
};

export const lastUsedMaxCount = 3;
